module.exports = __webpack_public_path__ + "img/pr-9.f9a1e060.png";